import { Map, OrderedMap } from 'immutable'
import * as actionTypes from './actionTypes'

const initialState = Map({
    all: Map({
        objects: OrderedMap({}),
        fetching: false,
        error: null,
    }),
    current: Map({
        fetching: false,
        saving: false,
        error: null,
        id: null,
    }),
    deletion: Map({
        inProgress: false,
        error: null,
    }),
    warehousingItem: Map({
        data: null,
        fetching: false,
        error: null,
    }),
})

function warehousingIssues(state = initialState, action) {
    switch (action.type) {
        // List
        case actionTypes.FETCH_STARTED:
            return state.setIn(['all', 'fetching'], true)
        case actionTypes.FETCH_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['all', 'objects'], action.payload).setIn(['all', 'fetching'], false).setIn(['all', 'error'], null)
            })
        case actionTypes.FETCH_REJECTED:
            return state.withMutations(map => {
                map.setIn(['all', 'fetching'], false).setIn(['all', 'error'], action.payload)
            })
        case actionTypes.FETCH_CANCELLED:
            return state.setIn(['all', 'fetching'], false)
        case actionTypes.SORTING_CHANGED:
            return state.setIn(['all', 'sorting'], action.payload)

        // One
        case actionTypes.FETCH_ONE_STARTED:
            return state.setIn(['current', 'fetching'], true)
        case actionTypes.FETCH_ONE_FULFILLED:
        case actionTypes.FETCH_ONE_REJECTED:
        case actionTypes.FETCH_ONE_CANCELLED:
            return state.setIn(['current', 'fetching'], false)

        // New/edit
        case actionTypes.SAVE_STARTED:
            return state.withMutations(map => {
                map.setIn(['current', 'saving'], true).setIn(['current', 'error'], null)
            })
        case actionTypes.SAVE_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['current', 'saving'], false).setIn(['current', 'error'], null).setIn(['current', 'id'], action.payload.get('id')).setIn(['all', 'objects', String(action.payload.get('id'))], action.payload)
            })
        case actionTypes.SAVE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['current', 'saving'], false).setIn(['current', 'error'], action.payload)
            })

        // Delete
        case actionTypes.DELETE_STARTED:
            return state.setIn(['deletion', 'inProgress'], true)
        case actionTypes.DELETE_FULFILLED:
            return state.deleteIn(['all', 'objects', action.payload]).withMutations(map => {
                map.setIn(['deletion', 'inProgress'], false).setIn(['deletion', 'error'], null)
            })
        case actionTypes.DELETE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['deletion', 'inProgress'], false).setIn(['deletion', 'error'], action.payload)
            })

        // Fetch item autocomplete
        case actionTypes.FETCH_ITEM_AUTOCOMPLETE_STARTED:
            return state.setIn(['warehousingItem', 'fetching'], true)
        case actionTypes.FETCH_ITEM_AUTOCOMPLETE_FULFILLED:
            return state.withMutations(map => {
                console.log('reducer', action.payload)
                map.setIn(['warehousingItem', 'data'], action.payload).setIn(['warehousingItem', 'fetching'], false).setIn(['warehousingItem', 'error'], null)
            })
        case actionTypes.FETCH_ITEM_AUTOCOMPLETE_REJECTED:
            return state.withMutations(map => {
                console.log('reducer', action.payload)
                map.setIn(['warehousingItem', 'fetching'], false).setIn(['warehousingItem', 'error'], action.payload)
            })
        case actionTypes.FETCH_ITEM_AUTOCOMPLETE_CANCELLED:
            return state.setIn(['warehousingItem', 'fetching'], false)

        default:
            return state
    }
}

export default warehousingIssues
